import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  opacity: 1
});

const Divider = defineStyleConfig({
  baseStyle
});

export default Divider;
